<script setup lang="ts">
import SimpleSpinner from "@/components/layouts/SimpleSpinner.vue";

interface Props {
  textKey?: string;
}

withDefaults(defineProps<Props>(), {
  textKey: "global.loading",
});
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]"
  >
    <div
      class="bg-white p-6 px-20 rounded-lg shadow-large flex flex-col items-center gap-4"
    >
      <SimpleSpinner size="8" />
      <p class="font-medium text-gray-600">{{ $t(textKey) }}</p>
    </div>
  </div>
</template>
